import React, {Fragment} from 'react';
import NP from 'number-precision';
import {withRouter} from "dva/router";
import DataConstant from "../../../utils/data-constant";
import CommonUtil from "../../../utils/common-util";
import {CouponFetch} from "../../../services/service";
import StorageUtil from "../../../utils/storage-util";
import {LocalConst} from "../../../utils/constant";
import {Modal, message} from "antd";
import SvgIcon from "../../../components/svg-icon";
import "./style.scss";
import {injectIntl} from 'react-intl';

@withRouter
@injectIntl
class ReceiveCoupon extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pdList: [],
            visibleReceiveCoupon: true
        }
    }

    componentDidMount() {
        this.isLogin = CommonUtil.isLogin();
        this.companyName = StorageUtil.getItem(LocalConst.companyName);
        if (this.isLogin) {
            this.listCouponActivityByShop();
        }
    }

    listCouponActivityByShop = () => {
        CouponFetch.listCouponActivityByShop({showCount: 9999}).then(rs => {
            console.log('listCouponActivityByShop==>', rs);
            if (rs.status === 1) {
                const pdList = rs.data.pdList = rs.data.pdList.filter(item => {
                    return item.form_status_ === 100 && item.receive_count_ < item.count_ && item.client_receive_count_ < item.limit_
                });
                this.setState({
                    pdList,
                }, () => {
                    if (this.state.pdList.length > 0 && !StorageUtil.getItem("isShowCouponList")) {
                        this.setState({
                            visibleModel: true
                        })
                    }
                });
            }
        })
    };

    receiveCoupon = () => {
        const {intl} = this.props;
        const {pdList} = this.state;
        const ids = [];
        let receive_num_ = 0, money = 0;
        pdList.forEach(item => {
            // 剩余数量
            let residue_count_ = item.count_ - item.receive_count_;
            let num = residue_count_ > item.limit_ ? item.limit_ : residue_count_;
            receive_num_ = NP.plus(receive_num_, num);
            money = NP.plus(money, NP.times(item.money_, num));
            ids.push(item.id_);
        });
        CouponFetch.batchReceiveCoupon({activity_ids_: ids.join(',')}, (rs) => {
            if (rs.status === 1) {
                this.setState({
                    visibleModel: false
                });
                Modal.confirm({
                    className: 'coupon-receive-success-modal',
                    centered: true,
                    title: <SvgIcon href={'icon-succeed'} className={'coupon-receive-success-icon'}/>,
                    content: <div>
                        <p className={'headline'}>
                            {
                                intl.formatMessage(
                                    {id: 'GXNHD_Z_YHQ', defaultValue: `恭喜您获得${receive_num_}张优惠券`},
                                    {num: receive_num_}
                                )
                            }
                        </p>
                        <p className={'total'}>
                            {
                                intl.formatMessage(
                                    {id: 'G_Y', defaultValue: `共${money}元`},
                                    {price: money}
                                )
                            }
                        </p>
                    </div>,
                    cancelText: intl.messages.QuXiao || '取消',
                    okText: intl.messages.LiJiShiYong || '立即使用',
                    onOk: this.toUseCoupon
                });

            } else {
                message.info(rs.message)
            }
        });
    };

    closeModal = () => {
        StorageUtil.setItem('isShowCouponList', true);
        this.setState({
            visibleModel: false,
        })
    };
    toUseCoupon = () => {
        const {history} = this.props;
        history.push("/goods/list");
    };

    render() {
        const {intl} = this.props;
        const {pdList, visibleModel} = this.state;
        if (!visibleModel) return null;
        return <Fragment>
            <div className="coupon-model">
                <div className="coupon-model-title">{this.companyName}</div>
                <div className={'coupon-model-tips'}>{intl.messages.GNFYHQL || '给您发优惠券啦'}</div>
                <div className={'coupon-modal-body'}>
                    {
                        pdList.map(item => {
                            const num = Math.min(item.limit_, item.count_);
                            if (item.validity_type_ === 1) {
                                item.begin_time_ = item.begin_time_.replace(/-/g, '.').substr(0, 11);
                                item.end_time_ = item.end_time_.replace(/-/g, '.').substr(0, 11);
                            }

                            return <div key={item.id_} className={'coupon-modal-item'}>
                                <div className={'money-box'}>
                                    <p className={'money'}>￥{item.money_}</p>
                                    <p className={'target'}>
                                        {
                                            intl.formatMessage(
                                                {id: 'Man1YuanKeYong', defaultValue: ` 满${item.target_money_}可用`},
                                                {num: item.target_money_, currencySymbol: this.currencySymbol}
                                            )
                                        }
                                    </p>
                                </div>
                                <div className={'rule-box'}>
                                    <p>
                                        <span className={'tag'}>{intl.messages[DataConstant.couponType[item.type_]]}</span>x{num}
                                    </p>
                                    <p className="name ellipsis-2">{item.name_}</p>
                                    {
                                        item.validity_type_ === 1 ?
                                            <p className={'time'}>{item.begin_time_} - {item.end_time_}</p> :
                                            <p className={'time'}>
                                                {
                                                    intl.formatMessage(
                                                        {id: 'LQH1TNKY', defaultValue: `领券后${item.validity_day_}天内可用`},
                                                        {day: item.validity_day_}
                                                    )
                                                }
                                            </p>
                                    }

                                </div>
                            </div>
                        })
                    }
                </div>
                <div className={'coupon-modal-operate'}>
                    <button className={'btn'} onClick={this.receiveCoupon}>{intl.messages['YiJianLingQu'] || '一键领取'}</button>
                </div>
                <div className="close" onClick={this.closeModal} role="none"/>
            </div>
            <div className="mask"/>
        </Fragment>;
    }
}

export default ReceiveCoupon;
